import { PriceRow } from "@/interfaces/PriceRow";
import { defineComponent, PropType, ref, watch } from "vue";

export default defineComponent({
  emits: ["toggleSidebar"],
  props: {
    view: {
      type: String,
      default: "tickets",
    },
    content: { type: Object, required: true },
    contactPerSubject: { type: Array, required: false },
    prices: { type: Array as PropType<PriceRow[]>, required: true },
  },
  setup(props, { emit }) {
    const searchinput = ref<HTMLInputElement | null>(null);

    const toggleSidebar = (e: Event): void => {
      e.preventDefault();
      emit("toggleSidebar", "none");
    };

    watch(
      () => props.view,
      (currentValue) => {
        if (currentValue === "search") {
          setTimeout(() => {
            const searchinput = document.querySelector(
              ".search__input"
            ) as HTMLElement;

            searchinput!.focus();
          }, 500);
        }

        if (currentValue === "contact") {
          setTimeout(() => {
            const firstInput = document.querySelector(
              ".contactform input"
            ) as HTMLElement;

            firstInput!.focus();
          }, 500);
        }
      }
    );

    return { searchinput, toggleSidebar };
  },
});
